import {
    CREATE_BUSINESS_CLIENT_STARTED,
    CREATE_BUSINESS_CLIENT_SUCCESS,
    CREATE_BUSINESS_CLIENT_FAILURE,
    SEARCH_BUSINESS_CLIENT_STARTED,
    SEARCH_BUSINESS_CLIENT_SUCCESS,
    SEARCH_BUSINESS_CLIENT_FAILURE,
    CLEAR_SEARCH_RESULT,
    REMOVE_ERROR_MESSAGE,
} from "../../constants/businessClient/businessClient";
import API from "../../../utils/API";
import { LOGOUT } from "../../constants/authenticate/authenticate";

export const createBusinessClient = (client) => {
    return (dispatch) => {
        dispatch(createBusinessClientStarted());
        API.post(`/business-clients/create`, client)
            .then((res) => {
                dispatch(createBusinessClientSuccess(res.data));
            })
            .catch((err) => {
                catchError(err, dispatch, createBusinessClientFailure);
            }).finally(() => {
                setTimeout(function () {
                    dispatch(removeErrorMessage());
                }, 1000);
            });
    };
};

const createBusinessClientStarted = () => ({
    type: CREATE_BUSINESS_CLIENT_STARTED,
});

const createBusinessClientSuccess = (client) => ({
    type: CREATE_BUSINESS_CLIENT_SUCCESS,
    payload: {
        client,
    },
});

const createBusinessClientFailure = (error) => ({
    type: CREATE_BUSINESS_CLIENT_FAILURE,
    payload: { error },
});

/**
 * Search business client based on query
 * @param {*} query
 */
export const searchBusinessClient = (query) => {
    return (dispatch) => {
        dispatch(searchBusinessClientStarted());
        API.get(`/business-clients/search?${query}`)
            .then((res) => {
                let data = {
                    clients: [],
                    count: 0
                }
                if (!res.data.clients) {
                    data.clients = res.data
                } else {
                    data.clients = res.data.clients
                    data.count = res.data.count
                }
                dispatch(searchBusinessClientSuccess(data));
            })
            .catch((err) => {
                catchError(err, dispatch, searchBusinessClientFailure);
            }).finally(() => {
                setTimeout(function () {
                    dispatch(removeErrorMessage());
                }, 1000);
            });
    };
};

const searchBusinessClientStarted = () => ({
    type: SEARCH_BUSINESS_CLIENT_STARTED,
});

const searchBusinessClientSuccess = (data) => ({
    type: SEARCH_BUSINESS_CLIENT_SUCCESS,
    payload: {
        clients: data.clients,
    },
});

const searchBusinessClientFailure = (error) => ({
    type: SEARCH_BUSINESS_CLIENT_FAILURE,
    payload: { error },
});

/**
 * Clear the client search result
 */
export const clearSearchResult = () => {
    return {
        type: CLEAR_SEARCH_RESULT,
    };
};

const removeErrorMessage = () => ({
    type: REMOVE_ERROR_MESSAGE,
});

const logoutUser = () => ({
    type: LOGOUT,
});

//Handle catch error
//logout use when unauthorized
//display error message and remove message after 3 seconds
const catchError = (err, dispatch, nextFunction) => {
    var message = err.message;
    if (err.response) {
        message = err.response.data.message;
        if (err.response.status === 401) {
            dispatch(logoutUser());
        }
    }
    dispatch(nextFunction(message));
};